import axios from "axios";

import { TYPE } from "./types";

import * as Constants from "../../constants";

import { validateReqBodyFn, requestHeadersKeyValues } from './validateRequestBodyFn';

export function getGeneralComment(data) {

    let apiToken = JSON.parse(localStorage.getItem(Constants.USER_DATA)).token;
    const apiRoute = Constants.SUPER_ADMIN_API + '/' + TYPE.GET_GENERAL_COMMENT;
    const request = axios
      .post(apiRoute, validateReqBodyFn(data), { headers: requestHeadersKeyValues() })
      .then(response => response.data);
    return {
      type: TYPE.GET_GENERAL_COMMENT,
      payload: request
    }
  }
  
  export function getPaymentComment(data) {

    let apiToken = JSON.parse(localStorage.getItem(Constants.USER_DATA)).token;
    const apiRoute = Constants.SUPER_ADMIN_API + '/' + TYPE.GET_PAYMENT_COMMENT;
    const request = axios
      .post(apiRoute, validateReqBodyFn(data), { headers: requestHeadersKeyValues() })
      .then(response => response.data);
    return {
      type: TYPE.GET_PAYMENT_COMMENT,
      payload: request
    }
  }
  